<template>
    
    <div 
    
    class="w-10 h-10 bg-gray-200 hover:bg-gray-300 flex items-center justify-center rounded-cs-md cursor-pointer" 
    
    @click.stop="$emit('clicked')"
    
    >

        <img :src="icon" alt="icon" >

    </div>

</template>

<script>

    export default {

        name: 'Button',

        props: {

            icon: String,
            danger: Boolean

        }

    }

</script>